import { api, API_BASE_URL } from './client';

// Attachments API
export const attachmentsApi = {
  getByTask: (taskId: string) =>
    api.get<{ attachments: import('../types').Attachment[] }>(`/attachments/tasks/${taskId}/list`),

  delete: (id: string) => api.delete<{ message: string }>(`/attachments/${id}`),

  getDownloadUrl: (id: string) => Promise.resolve({ url: `${API_BASE_URL}/attachments/${id}` }),
};
